import type { IconSvgObject } from './types';

const TouchLocked03Icon: IconSvgObject = [
  ["path", { d: "M12 21H9.07C8.4015 21 7.77719 20.666 7.40622 20.1099L3.38941 14.0883C2.87331 13.4531 2.86987 12.5441 3.38114 11.905C3.99565 11.1369 5.12437 11.0308 5.87124 11.671L8.00514 13.5V3.75C8.00514 2.7835 8.78864 2 9.75514 2C10.7216 2 11.5051 2.7835 11.5051 3.75V10H16.5C17.3885 10 17.9507 10.3863 18.5 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 17V15.5C19.5 14.6716 18.8284 14 18 14C17.1716 14 16.5 14.6716 16.5 15.5V17M15 17H21V22H15V17Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TouchLocked03Icon;
